export const FIRM = {
  name: "Law Offices of Arjun Singh & Associates",
  advocate: "Advocate Arjun Singh",
  experience: "14",
  courts: "High Courts & District Courts across Madhya Pradesh",
  address: "781, Napier Town, Jabalpur, Madhya Pradesh — 482001",
  mobile: "9617403399",
  mobileIntl: "919617403399",
  email: "law.arjunsingh@gmail.com",
};

export const PRACTICE_AREAS = [
  { n: "01", title: "Arbitration", desc: "Commercial dispute resolution outside the courtroom with strategic advocacy." },
  { n: "02", title: "Matrimonial", desc: "Divorce, judicial separation and family disputes handled with discretion." },
  { n: "03", title: "Dowry Cases", desc: "Defence and prosecution under dowry prohibition statutes." },
  { n: "04", title: "Look Out Circulars", desc: "Quashing, challenge and legal remedies against LOCs." },
  { n: "05", title: "Domestic Violence", desc: "Protection, residence and relief under the DV Act." },
  { n: "06", title: "Maintenance u/s 144 BNSS", desc: "Interim and permanent maintenance proceedings." },
  { n: "07", title: "Alimony & Maintenance", desc: "Fair settlements and enforcement of maintenance orders." },
  { n: "08", title: "Legal Inheritance", desc: "Succession, wills and inheritance dispute resolution." },
  { n: "09", title: "Property Law", desc: "Title disputes, partition and property transactions." },
  { n: "10", title: "Contractual Matters", desc: "Drafting, review and litigation of contracts." },
  { n: "11", title: "Tender Matters", desc: "Bid disputes, blacklisting and procurement litigation." },
  { n: "12", title: "Writ Petitions", desc: "Constitutional remedies before the High Court." },
  { n: "13", title: "Debt Recovery Matters", desc: "Recovery proceedings, DRT actions and enforcement of dues." },
  { n: "14", title: "Commercial Matters", desc: "Business disputes, commercial suits and corporate advisory." },
  { n: "15", title: "Army Law", desc: "General Court Martials and allied army laws and procedure." },
  { n: "16", title: "Criminal Trials", desc: "Defence and prosecution across criminal trials, bail and appeals." },
];

export const SERVICES = [
  { title: "Representations", desc: "Appearance and advocacy before the High Courts, District Courts, Family Courts, Tribunals and Authorities across Madhya Pradesh." },
  { title: "Legal Notices", desc: "Drafting and dispatch of precise, legally sound notices that protect your position." },
  { title: "Document Review", desc: "Meticulous scrutiny of agreements, deeds and case files to safeguard your interests." },
  { title: "AI Document Review", desc: "Get your AI-generated documents reviewed — a careful check that surfaces risks, missing clauses and inconsistencies before you rely on them." },
  { title: "Second Opinions", desc: "An independent, considered assessment of your ongoing matter and the strategy ahead." },
  { title: "Consultation & Advisory", desc: "Clear, strategic legal counsel tailored to your matter and objectives." },
];

export const CHAPTERS = [
  { n: "01", title: "Heritage", desc: "Fourteen years of disciplined practice, rooted in the courts of Madhya Pradesh." },
  { n: "02", title: "Precision", desc: "Every notice, petition and argument crafted with rigour and clarity." },
  { n: "03", title: "Trust", desc: "Confidential counsel and a relationship built on candour and reliability." },
];
